import { render, staticRenderFns } from "./embolizationCalculation.vue?vue&type=template&id=811f268c&scoped=true&"
import script from "./embolizationCalculation.vue?vue&type=script&lang=js&"
export * from "./embolizationCalculation.vue?vue&type=script&lang=js&"
import style0 from "./embolizationCalculation.vue?vue&type=style&index=0&id=811f268c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811f268c",
  null
  
)

export default component.exports